import React from 'react';

// Utils
import { useTranslation } from 'next-i18next';
import { useAppContext } from '../../../src/store/AppContext';
import { useModal } from '../../../src/store/ModalContext';

// Components
import Button from '../../atoms/Button/Button';
import Modal from '../../organisms/Modal/Modal';

import styles from './WarningFirstPlayer.module.scss';

function WarningFirstPlayer() {
  const { t } = useTranslation();
  const [{ players }] = useAppContext();
  const { isModalOpen, closeModal, setModalDataById } = useModal();

  const isOpen = isModalOpen('modal-warning-first-player');

  const handleClose = () => closeModal('modal-warning-first-player');

  const handleConfirm = () => {
    setModalDataById('modal-warning-first-player', { reset: true });
    closeModal('modal-warning-first-player');
  };

  return (
    <Modal
      id="modal-warning-first-player"
      title={t('booking.choice.warningDeletion.title')}
      isOpen={isOpen}
      onClose={handleClose}
    >
      <p className={`${styles.modal_content} m-t-20 fw-400`}>
        {players?.length > 1 ? t('booking.choice.warningDeletion') : t('booking.choice.warningDeletion.singlePlayer')}
      </p>
      <div className="flex a-center j-spb m-t-30 mobile-d-col">
        <Button
          aria-label="Close modal"
          onClick={handleClose}
          classNames="flex-auto m-r-20 mobile-w-100 mobile-m-r-0 mobile-m-b-10"
          text="uppercase"
          color="inverted-secondary"
        >
          {t('common.cancel')}
        </Button>
        <Button
          onClick={handleConfirm}
          classNames="flex-auto mobile-w-100"
          text="uppercase"
        >
          {t('booking.choice.warningDeletion.confirm')}
        </Button>
      </div>
    </Modal>
  );
}

WarningFirstPlayer.propTypes = {};

export default WarningFirstPlayer;
